let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let ProOnly = require("../../../../widgets/ProOnly");
let FormUtils = require("../../../../../utils/FormUtils");
let Constants = require("../../../../../utils/Constants");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let HoldCompetitionModal = require("./HoldCompetitionModal");
let createStandardEventForm = require("../../createStandardEventForm");
let isEventAccountingLockedForMe = require("../../../../../utils/isEventAccountingLockedForMe");

let DaForm = createStandardEventForm({
	eventToInitialValues(event){
		return {
			organization: event.organization,
			meetingname: event.meetingname,
			status: event.status,
			holdPriority: event.holdPriority,
			isPersonal: !!event.isPersonal,
			deliveryMethod: event.deliveryMethod,
			zoomUrl: event.zoomUrl,
			coaching: !!esUtils.getIn(event, ["flags_as_map", "coaching", "is_set"]),
			saleClosed: !!esUtils.getIn(event, ["flags_as_map", "sale_closed", "is_set"]),
			eventClass: event.eventClass,
			arrivalNotes: event.arrivalNotes || '', // default to blank otherwise IE11 fires an onchange event which shows the EventFormUnsavedChangeMixin modal @see https://www.pivotaltracker.com/story/show/152897695
			companyID: event.companyID,
			evalLink: _.get(event, ["Evaluation", "eval_link"]) || '',
			evaluation_type: _.get(event, ["Evaluation", "evaluation_type"]) || 0
		};
	},
	buildSchema({event, read_only, Displaylists}, data){
		let has_pro = (_.intersection(AuthedUserSession.getSIDsAtPackageLevel("PRO"), event && event.sids).length > 0);
		let ulists = (Displaylists && Displaylists.universal) || {};
		let schema = {
			organization: {
				type: "text",
				label: "Presenting to",
				placeholder: "Presenting to",
				validate: FormUtils.v.required
			},
			meetingname: {
				type: "text",
				label: "Event Reason",
				placeholder: "Event Reason"
			},
			"status": {
				type: "select",
				label: "Status",
				read_only: AuthedUserSession.privatelabel_code === "cs" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
				placeholder: "-- select a status --",
				options: _.object(_.map(ulists.eventstatuses, function (d) {
					return [d.description, d.description];//yep the description is the key
				})),
				validate(s){
					if (!AuthedUserSession.is_st_family && s == "lead" && !has_pro) {
						return "Only PRO users can have '" + s + "' events";
					}
					return true;
				}
			},
			isPersonal: {
				label: "Personal/Blackout",
				type: "checkbox"
			},
			deliveryMethod: {
				type: "select",
				label: "Event Type",
				placeholder: "-- select an event type --",
				options: _.object(_.map(ulists.deliverymethods, function (d) {
					return [d.id, d.description];
				}))
			},
			arrivalNotes: {
				type: "textarea",
				label: "Schedule Notes",
				placeholder: "Schedule Notes"
			}
		};
		if (esUtils.toInt(data.deliveryMethod) === 2) {
			schema.zoomUrl = {
				type: "textarea",
				label: "Meeting URL",
				rows: 2,
				placeholder: "Enter Meeting URL (Zoom, Webex, Hangouts, etc)"
			};
		}
		if (!read_only && (data.status === "held")) {
			schema.holdPriority = {
				label: "Hold Strength",
				type: "select",
				options: Constants.HOLD_PRIORITY,
				dont_sort_options: true,
				validate(s){
					return true;
				}
			};
		}
		if (AuthedUserSession.is_st_family) {
			let evaluation_types = _.get(Displaylists, ["sitelists", "evaluation_types"], []);

			schema.deliveryMethod.label = "Delivery Method";
			schema.deliveryMethod.placeholder = "-- select a delivery method --";
			schema.eventClass = {
				type: "select",
				label: "Event Type",
				placeholder: "-- select an event type --",
				options: _.object(_.map(ulists.eventclass, function ({id, name}) {
					return [id, name];
				})),
				read_only: isEventAccountingLockedForMe(event),
				validate: FormUtils.v.optional
			};
			schema.companyID = {
				label: "Company",
				type: "select",
				options: _.object(_.map(ulists.company, function ({id, name}) {
					return [id, name];
				})),
				validate: FormUtils.v.optional,
				onChange: (e) => {
					//console.log(e);
				}
			};
			schema.saleClosed = {
				label: "event closed",
				type: "checkbox"
			};
			schema.coaching = {
				label: "virtual coaching",
				type: "checkbox"
			};
			// Only show evaluation link if the evaluation is set as electronic
			if (_.get(_.find(evaluation_types, {"id": _.parseInt(data.evaluation_type)}), ["electronic"], 0) === 1) {
				schema.evalLink = {
					label: "Evaluation Link",
					type: 'text',
					validate: FormUtils.v.optional,
					read_only: true
				};
			}
		}
		return schema;
	},
	writeInputDataToEvent(data, event){
		event.organization = data.organization;
		event.meetingname = data.meetingname;
		event.status = data.status;
		event.isPersonal = !!data.isPersonal;
		event.holdPriority = data.holdPriority;
		event.deliveryMethod = data.deliveryMethod;
		event.zoomUrl = data.zoomUrl;
		event.arrivalNotes = data.arrivalNotes;
		if (AuthedUserSession.is_st_family) {
			event.eventClass = esUtils.toInt(data.eventClass);
			event.companyID = esUtils.toInt(data.companyID);
			event.flags_as_map.coaching.is_set = !!data.coaching;
			event.flags_as_map.sale_closed.is_set = !!data.saleClosed;
		}
	},
	confirmMessageBeforeSave(old_event, new_event) {
		if (AuthedUserSession.is_st_family) {
			if (old_event.companyID !== new_event.companyID) {
				return dd.span({},
						dd.span({},
								"You have changed the event COMPANY.  This will affect the PD Rep, Sales Rep and Specific Content Area.  The old values will be saved as notes on this event."),
						dd.br(),
						dd.br(),
						dd.span({},
								"Once you change the event COMPANY, you may lose access to this event if you are not authorized on the new company.")
				);
			}
		}
	},
	renderFields(){
		let fields = this.Form_buildSchema();
		let {event} = this.props;
		return dd.div(null,
			ezHorizontalFields(this, [
				["organization"],
				["meetingname"],
				["status"],
				["holdPriority"]
			]),
			_.has(fields, "holdPriority") && !_.isEmpty(event.Stagetime)//don't show this if there is no date
				? HorizontalFieldSpot(null,
				dd.a({href: "#", onClick: this.props.toggleHoldCompetition}, "view hold competition")
			)
				: null,
			ProOnly({sids: event.sids},
				ezHorizontalFields(this, [
					["isPersonal"]
				])
			),
			ezHorizontalFields(this, [
				["deliveryMethod"],
				["zoomUrl"],
				["coaching"],
				["saleClosed"],
				["eventClass"],
				["arrivalNotes"],
				["companyID"],
				["evalLink"]
			])
		);
	}
});

module.exports = dd.createClass({
	getInitialState(){
		return {show_hold_competition: false};
	},
	__toggleHoldCompetition: esUtils.wrapPreventDefault(function () {
		this.setState({show_hold_competition: !this.state.show_hold_competition});
	}),
	render(){
		let {event, Displaylists, read_only} = this.props;

		return dd.div(null,
			DaForm({event, Displaylists, read_only, toggleHoldCompetition: this.__toggleHoldCompetition, toggleCompanyChange: this.__toggleCompanyChange}),
			this.state.show_hold_competition ? HoldCompetitionModal({event, onClose: this.__toggleHoldCompetition}) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/BasicDetails.js